module.exports = __webpack_public_path__ + "img/pic20.19e9fd62.jpg";